export default __webpack_public_path__ + "static/media/teton-sioux.951fc06f.png";